export default __webpack_public_path__ + "static/media/CycleSport flyer.752eba99.pdf";